import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { PageLayout } from '@/components/layout/PageLayout'
import { PageHeader } from '@/components/layout/PageHeader'
import { PageHeaderActions } from '@/components/layout/PageHeaderActions'
import { usePermissions } from '@/hooks/usePermissions'
import { PermissionEntityType } from '@/api/model'
import type { ServiceConnectionType } from '@/api/model'
import { ServiceConnectionsTable } from './table-components/ServiceConnectionsTable'
import { ServiceConnectionDialog } from './components/ServiceConnectionDialog'
import { CreateServiceConnectionButton } from './header-actions-components/CreateServiceConnectionButton'

export default function ServiceConnectionsPage() {
  const { t } = useTranslation('service-connections')
  const { userHasPermission } = usePermissions()
  // ServiceConnections permissions are global (never per entity), so the plain check applies.
  const canEdit = userHasPermission(PermissionEntityType.ServiceConnections, 'Edit')

  const [createType, setCreateType] = useState<ServiceConnectionType | null>(null)
  const [editedId, setEditedId] = useState<number | null>(null)

  const closeDialog = () => {
    setCreateType(null)
    setEditedId(null)
  }

  return (
    <PageLayout>
      <PageHeader title={t('header.title')} description={t('header.description')}>
        {canEdit && (
          <PageHeaderActions>
            <CreateServiceConnectionButton onSelectType={setCreateType} />
          </PageHeaderActions>
        )}
      </PageHeader>

      <ServiceConnectionsTable canEdit={canEdit} onEdit={(connection) => setEditedId(connection.id)} />

      <ServiceConnectionDialog
        isOpen={createType !== null || editedId !== null}
        onOpenChange={(open) => !open && closeDialog()}
        createType={createType}
        connectionId={editedId}
      />
    </PageLayout>
  )
}
